import axios from 'axios'
import { useEffect, useState } from 'react'

const BASE_URL = process.env.REACT_APP_BASE_URL;

const UsersInterest = () => {
  const [interests, setInterests] = useState([])

  useEffect(() => {
    const fetchInterests = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/marketplace/researcher/interest/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'x-api-key': process.env.REACT_APP_X_API_KEY,
          },
        });

        setInterests(response.data); // ✅ FIXED
      } catch (error) {
        console.log('error while fetch interests', error)
      }
    }

    fetchInterests()
  }, [])

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">User Interests</h2>

      <div className="space-y-4">
        {interests.map((item) => (
          <div
            key={item.id}
            className="border rounded-2xl p-4 shadow-sm hover:shadow-md transition"
          >
            <div className="flex justify-between items-center mb-2">
              <p className="font-medium text-gray-800">
                {item.email}
              </p>
              <span
                className={`text-sm px-3 py-1 rounded-full ${
                  item.status === "pending"
                    ? "bg-yellow-100 text-yellow-700"
                    : item.status === "accepted"
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {item.status}
              </span>
            </div>

            <p className="text-gray-600 text-sm mb-1">
              📞 {item.phone}
            </p>

            <p className="text-gray-700">
              {item.message}
            </p>

            <p className="text-xs text-gray-400 mt-2">
              {new Date(item.created_at).toLocaleString()}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default UsersInterest